import Vue from 'vue';
import { config } from '@app';

new Vue({
    components: {
        // load component async
        DropdownLogoutButton: () => import('@app/components/DropdownLogoutButton'),
        SearchNav: () => import('@app/components/search/SearchNav'),
        SvgIcon: () => import('@app/components/SvgIcon'),
    },
    mixins: [config],
});
